import {  Spinner,  } from "@chakra-ui/react";

export default function Loading() {
  return <Spinner color='red.500' />
}
